import React from 'react';

import { reportMykissError } from '../../helpers/errorHandling';
import { ErrorBanner } from '../ErrorBanner/ErrorBanner';

interface IState {
  hasError: boolean;
}

interface IProps {
  children: React.ReactNode;
}

class MapboxErrorBoundary extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): IState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    reportMykissError(error);
  }

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <div className="mx-auto my-6 max-w-screen-md">
          <ErrorBanner
            errors={['An error occurred while loading the map. Refresh the page to try again.']}
          />
        </div>
      );
    }

    return children;
  }
}

// Default export as class component

export default MapboxErrorBoundary;
